module.exports = __webpack_public_path__ + "static/media/EchoHeal.0dcdb6dd.png";